import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { callAll } from '../../utils';
import { States, useDropdown } from './Context';
import { SET_NAVIGATING_WITH_KEYBOARD } from './constants';
const Items = forwardRef(({ as: Element = 'ul', children, 'data-position': dataPosition = 'bottom-end', onMouseMove = () => { }, className, ...rest }, ref) => {
    var _a;
    const { activeItemIndex, getItemsId, id, state, dispatch, items } = useDropdown();
    const internalRef = useRef(null);
    const itemsId = getItemsId();
    useImperativeHandle(ref, () => internalRef.current, [internalRef]);
    const handleMouseMove = () => {
        dispatch({ type: SET_NAVIGATING_WITH_KEYBOARD, value: false });
    };
    return (_jsx(Element, { "aria-labelledby": `dropdown-${id}-button`, "aria-activedescendant": activeItemIndex >= 0 ? (_a = items[activeItemIndex]) === null || _a === void 0 ? void 0 : _a.id : undefined, className: className, "data-open": state === States.Open, "data-position": dataPosition, id: itemsId, ref: internalRef, role: "menu", tabIndex: -1, onMouseMove: callAll(onMouseMove, handleMouseMove), hidden: state === States.Closed, ...rest, children: state === States.Open && children }));
});
Items.displayName = 'Items';
export { Items };
//# sourceMappingURL=Items.js.map